var map = {
	"./Case_Havelaar_1920x1080_1-low.jpg": 35522,
	"./Case_Havelaar_1920x1080_2-low.jpg": 29753,
	"./Case_Havelaar_1920x1080_3-low.jpg": 15040,
	"./Case_Havelaar_1920x1080_4-low.jpg": 78415,
	"./Case_Havelaar_1920x1080_5-low.jpg": 26798,
	"./Case_Havelaar_1920x1080_6-low.jpg": 94485,
	"./Case_Havelaar_1920x1080_7-low.jpg": 42636,
	"./Case_Havelaar_1920x1080_8-low.jpg": 18987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55925;